// extracted by mini-css-extract-plugin
module.exports = {"Home":"Home_Home__1gwGJ"};